export const ConfigureOptions  = {
    Model : "Model" ,
    ModelLayeredMedia : "Model-Layered Media",
    AssignOptions : "Assign Options to Section",
    Options : "Options",
    ConfigureChoices : "Choices",
    ChoiceLayeredMedia : "Choices-Layered Media"
} 